// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__26yMC","large":"Index_large__2tzJz","small":"Index_small__uhasy"};